import { Backdrop, Dialog, DialogProps } from '@mui/material';
import { uniqueId } from 'lodash';
import React, { useState } from 'react';
import Draggable from 'react-draggable';

import { useSxStyles } from '~/components/Dialogs/components/DraggableDialog/useStyles';
import { mergeSxProps } from '~/utils/helpers/sxProps';

type DraggableDialogProps = DialogProps & {
  showPortalBars?: boolean;
};

export const DraggableDialog = (props: DraggableDialogProps) => {
  const { children, showPortalBars, ...dialogProps } = props;
  const sxStyles = useSxStyles();

  const [dialogId] = useState(uniqueId('draggable-dialog-'));

  if (dialogProps.fullScreen) {
    return (
      <Dialog
        {...dialogProps}
        sx={mergeSxProps(
          dialogProps.sx,
          showPortalBars ? sxStyles.showPortalBarsOnFullScreen : undefined,
        )}
      >
        {children}
      </Dialog>
    );
  }

  return (
    <Backdrop
      open={!dialogProps.hideBackdrop && dialogProps.open}
      sx={sxStyles.backdrop}
    >
      <Draggable
        handle={`#${dialogId}`}
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Dialog {...dialogProps} hideBackdrop={true} aria-labelledby={dialogId}>
          {children}
        </Dialog>
      </Draggable>
    </Backdrop>
  );
};
